import React, { useState } from 'react';
import { Check } from 'lucide-react';

interface ColorPaletteProps {
  isOpen: boolean;
  selectedColor: string;
  handleSelectColor: (color: string) => void;
}

export const ColorPalette: React.FC<ColorPaletteProps> = ({ isOpen, selectedColor, handleSelectColor }) => {
  const [inputValue, setInputValue] = useState(selectedColor);

  const colorPalette = [
    ['#000000', '#424242', '#616161', '#757575', '#9E9E9E', '#BDBDBD', '#E0E0E0', '#FFFFFF'],
    ['#FF0000', '#FF9800', '#FFEB3B', '#00FF00', '#00FFFF', '#0000FF', '#9C27B0', '#FF00FF'],
    ['#FFCDD2', '#FFE0B2', '#FFF9C4', '#DCEDC8', '#B2EBF2', '#BBDEFB', '#D1C4E9', '#F8BBD0'],
    ['#EF9A9A', '#FFCC80', '#FFF59D', '#C5E1A5', '#80DEEA', '#90CAF9', '#B39DDB', '#F48FB1'],
    ['#E57373', '#FFB74D', '#FFF176', '#AED581', '#4DD0E1', '#64B5F6', '#9575CD', '#F06292'],
    ['#EF5350', '#FFA726', '#FFEE58', '#9CCC65', '#26C6DA', '#42A5F5', '#7E57C2', '#EC407A'],
    ['#F44336', '#FF9800', '#FFEB3B', '#8BC34A', '#00BCD4', '#2196F3', '#673AB7', '#E91E63'],
    ['#D32F2F', '#F57C00', '#FBC02D', '#689F38', '#0097A7', '#1976D2', '#512DA8', '#C2185B'],
    ['#B71C1C', '#E65100', '#F57F17', '#33691E', '#006064', '#0D47A1', '#311B92', '#880E4F']
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSelectColor(inputValue);
  };

  if (!isOpen) return null;

  return (
    <div className='absolute left-0 top-full z-50 mt-1 w-64 rounded-md border border-gray-200 bg-white p-2 shadow-lg'>
      <div className='custom-scrollbar scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 max-h-16 overflow-y-auto pr-1'>
        <div className='grid gap-1'>
          {colorPalette.map((row, rowIndex) => (
            <div key={rowIndex} className='flex gap-1'>
              {row.map(color => (
                <button
                  key={color}
                  type='button'
                  className={`h-6 w-6 rounded-sm border border-gray-300 hover:ring-2 hover:ring-blue-300 ${selectedColor === color ? 'ring-2 ring-blue-500' : ''}`}
                  style={{ backgroundColor: color }}
                  onClick={() => handleSelectColor(color)}
                  aria-label={`Select color ${color}`}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
